import artifacts from "#/shared/utils/artifacts"

import MezoNativeBTC from "./MezoNativeBTC"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
  testnetAddress: "0x517f2982701695D4E52f1ECFBEf3ba31Df470161",
  mezoTestnetAddress: MezoNativeBTC.address,
  mezoMainnetAddress: MezoNativeBTC.address,
})
